<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <h3>推广{{ isThirdParty ? '子渠道' : '位'}}</h3>
      <div class="refresh" v-if="isThirdParty">统计转化情况和财务结算使用</div>
      <div class="refresh" v-else>创建推广渠道和推广位，用于统计不同推广位的转化效果</div>
      <el-button v-if="judeRole" class="button-style" type="primary" icon="el-icon-plus" @click="create">{{ isThirdParty ? '添加达人' : '创建推广位' }}</el-button>
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :header-cell-style="tableHeader">
        <el-table-column :label="isThirdParty ? '推广位/子渠道ID' : '推广位ID'" align="center">
          <template slot-scope="{row}">
            <span>{{ row.promotionPositionCode}}</span>
          </template>
        </el-table-column>
        <template v-if="isThirdParty">
          <el-table-column label="达人昵称" align="center">
            <template slot-scope="{row}">
              <span>{{ row.authorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="达人ID" align="center">
            <template slot-scope="{row}">
              <span>{{ row.authorId }}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column label="推广位名称" align="center">
            <template slot-scope="{row}">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="推广渠道名称" align="center" class="channelRow">
            <template slot-scope="scope">
              <div class="cellStyle" @mouseleave="loseLeave(scope.$index, scope.row)">
                <span class="channelCell" @mouseenter="loseFcous(scope.$index, scope.row)">
                  {{ scope.row.channelName || '--' }}
                  <i v-show="showVisiable && (editIndex == scope.$index)" class="el-icon-edit-outline iconEdit" @click="editchannelName(scope.row)"></i>
                </span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="推广渠道ID" align="center">
          <template slot-scope="{row}">
            <span>{{ row.channelCode || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="isThirdParty ? '生成时间' : '创建时间'">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="isEdit ? '编辑推广位' : '创建推广位'" :visible.sync="dialogVisible" width="605px" :before-close="cancelDialog">
        <el-form :model="editQuery" :rules="LevelSRules" label-width="110px" ref="positionRef">
          <el-form-item v-if="isEdit" prop="chanenel" label="推广渠道">
            <span>{{editQuery.channelName}}</span>
          </el-form-item>
          <el-form-item v-if="!isEdit && flag === 1" prop="channelCode" label="推广渠道">
            <el-select v-model="editQuery.channelCode" filterable placeholder="从已有渠道选择" class="selectWidth">
              <el-option
                v-for="item in channelList"
                :key="item.id"
                :label="item.name"
                :value="item.promotionChannelCode">
              </el-option>
            </el-select>
            <el-button type="text" class="colorStyle" @click="handleChannel(2)">创建新渠道</el-button>
          </el-form-item>
          <el-form-item v-if="!isEdit && flag === 2" prop="channelName" label="推广渠道">
            <el-input v-model="editQuery.channelName" placeholder="输入新渠道名称" class="selectWidth" />
            <el-button type="text" class="colorStyle" @click="handleChannel(1)">从已有渠道中选择</el-button>
          </el-form-item>
          <el-form-item prop="name" label="推广位">
            <el-input v-model="editQuery.name" placeholder="请输入推广位名称" class="selectWidth" />
          </el-form-item>
          <template v-if="isThirdParty">
            <el-form-item prop="authorName" label="达人昵称">
              <el-input v-model="editQuery.authorName" placeholder="请输入达人昵称" class="selectWidth" />
            </el-form-item>
            <el-form-item prop="authorId" label="达人ID">
              <el-input v-model="editQuery.authorId" placeholder="请输入达人ID" class="selectWidth" />
            </el-form-item>
          </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog()">保 存</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="modalVisible"
        width="420px"
        :before-close="handleClose">
        <el-form :model="editQueryNew" :rules="LevelARules" ref="positionRefA">
          <el-form-item prop="channelNameNew">
            <el-input v-model="editQueryNew.channelNameNew" placeholder="请输入推广渠道名称" />
            <p>渠道名称修改将应用到所有相关推广位</p>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="modalVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmDialogNew()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { getPromotionList, editProduct, addProduct, getChannelList, updateChannel } from "@/services/promotion";
import PowerWrapper from "@/components/PowerWrapper";
import { delUndefined, numFormat, timestampToDateTotal } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole, isThirdParty } from '@/utils/auth'

export default {
  name: "promotion",
  components: {
    PowerWrapper
  },
  data() {
    return {
      isThirdParty: isThirdParty(),
      CurrRole: "promotion",
      list: [],
      listQuery: {
        current: 1,
        pageSize: 10,
        orderId: null,
        userId: null,
        productName: null,
        status: null,
        productType: 1,
        payTime: 1,
        startTime: null,
        endTime: null
      },
      listLoading: false,
      dialogVisible: false,
      editQuery: {
        channelName: null,
        name: null,
        channelCode: null,
        id: null
      },
      LevelSRules: {
        channelCode: [
          { required: true, message: "请选择推广渠道", trigger: ['blur', 'change'] },
        ],
        channelName: [
          { required: true, message: "请输入推广渠道名称", trigger: ['blur', 'change'] },
          {
            validator: (rule, val, cb) => {
              if (val && val.length > 12) {
                cb(new Error('渠道名称过长，请重新输入'))
              } else {
                cb()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        name: [
          { required: true, message: "请输入推广位名称", trigger: ['blur', 'change'] },
          {
            validator: (rule, val, cb) => {
              if (val && val.length > 12) {
                cb(new Error('推广位名称过长，请重新输入'))
              } else if (val && val === '默认推广位') {
                cb(new Error('推广位已存在，请重新输入'))
              } else {
                cb()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        authorName: [
          { required: isThirdParty(), message: "请输入达人昵称", trigger: ['blur'] },
        ],
        authorId: [
          { required: isThirdParty(), message: "请输入达人ID", trigger: ['blur'] },
        ],
      },
      editQueryNew: {
        channelNameNew: null,
        promotionChannelCode: null,
        teamCode: null
      },
      LevelARules: {
        channelNameNew: [
          { required: true, message: "请输入推广渠道名称", trigger: ['blur', 'change'] },
          {
            validator: (rule, val, cb) => {
              if (val && val.length > 12) {
                cb(new Error('渠道名称过长，请重新输入'))
              } else {
                cb()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      flag: 1,
      isEdit: false,
      channelList: [],
      showVisiable: false, // 控制显隐
      editIndex: -1, // 当前编辑行index
      modalVisible: false,
      channelNameNew: null
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    },
    judeRole() {
      return getTeamRole() && (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2)
    },
  },
  created() {
    // 列表查询
    this.getList()
  },
  methods: {
    handleClose () {
      this.modalVisible = false;
    },
    editchannelName(item) {
      this.editQueryNew.channelNameNew = item.channelName || '';
      this.editQueryNew.promotionChannelCode = item.channelCode || ''
      this.editQueryNew.teamCode = item.teamCode || ''
      this.modalVisible = true;
    },
    loseFcous (index) {
      this.editIndex = index;
      this.showVisiable = true;
    },
    loseLeave () {
      this.showVisiable = false;
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    numberFormat(num) {
      return numFormat(num)
    },
    handleChannel(e) {
      this.flag = e;
    },
    getList(btnName) {
      this.listLoading = true;
      const params = {
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.listLoading = false;
          const orderList = res.data.data;
          this.list = orderList;
          if (btnName === 'search') {
            this.listQuery.current = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.list = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    handleSearch() {
      this.getList('search');
    },
    create() {
      // 获取推广渠道
      this.getChannelList()
      if (this.$refs.positionRef) this.$refs.positionRef.resetFields();
      this.dialogVisible = true;
      this.isEdit = false;
      // 清空数据
      this.editQuery.channelName = null;
      this.editQuery.channelCode = null
      this.editQuery.name = null;
    },
    edit(item) {
      this.dialogVisible = true;
      this.isEdit = true;
      this.editQuery.id = item.id;
      this.editQuery.name = item.name;
      this.editQuery.channelName = item.channelName;
      this.editQuery.channelCode = item.channelCode;
      if (this.$refs.positionRef) {
        this.$refs.positionRef.clearValidate('channelCode')
        this.$refs.positionRef.clearValidate('channelName')
      }
    },
    cancelDialog() {
      this.dialogVisible = false;
    },
    confirmDialog() {
      const { editQuery, flag } = this
      this.$refs.positionRef.validate(async (valid) => {
        if (valid) {
          const { channelCode, name, channelName, id, authorName, authorId } = editQuery
          const params = {
            authorName,
            authorId,
            channelName: flag === 2 ? channelName : null,
            channelCode: flag === 1 ? channelCode : null,
            name,
            teamCode: getTeamCode(),
            createAgentCode: getAgentCode()
          }
          if (this.isEdit) { // 编辑
            editProduct({
              type: 'PUT',
              params: {
                id: id ? Number(id) : null,
                name
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: "编辑推广位成功" })
                this.getList();
                this.dialogVisible = false;
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          } else {
            addProduct({
              type: 'POST',
              params: {
                ...delUndefined(params)
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: "创建推广位成功" })
                this.getList();
                this.dialogVisible = false;
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          }
        } else {
          this.$message({ type: 'error', message: "请完整填写信息" })
        }
      })
    },
    confirmDialogNew() {
      const { editQueryNew } = this
      this.$refs.positionRefA.validate(async (valid) => {
        if (valid) {
          const { promotionChannelCode, channelNameNew, teamCode } = editQueryNew
          const params = {
            channelName: channelNameNew,
            channelCode: promotionChannelCode,
            teamCode
          }
          updateChannel({
            type: 'POST',
            params: {
              ...delUndefined(params)
            }
          }).then(res => {
            if (res.data && res.data.errCode === 0) {
              this.$message({ type: 'success', message: "渠道名称修改成功" })
              this.getList();
              this.modalVisible = false;
            } else if (res.data && res.data.errCode === 1016) {
              this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
              Cookie.remove('staffToken')
              setTimeout(() => {
                this.$router.push({ path: '/login' })
              }, 3000)
            } else {
              this.$message({ type: 'error', message: res.data.errMsg })
            }
          })
        } else {
          this.$message({ type: 'error', message: "请完整填写信息" })
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.exportExcel {
  float: right;
  margin-bottom: 10px;
}
.distributorList {
  position: relative;
  .btnsStyle{
    display: inline-block;
    margin-left: 20px;
    color:#FF9900;
  }
  .selectWidth{
    width: 300px;
  }
  .colorStyle{
    display: inline-block;
    color:#FF9900;
  }
  .inputWidth{
    width: 380px;
  }
  .blue{
    color:#409EFF;
  }
  .channelRow{
    position: relative;
  }
  .cellStyle{
    .channelCell{
      display: inline-block;
      width: 100%;
      cursor: pointer;
      .iconEdit{
        width: 10%;
        position: absolute;
        margin-top: 2px;
        right: 10px;
        font-size: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
